import React from "react";
import { Form, Message, Popup, Icon, Header, Button } from "semantic-ui-react";

function Sales(props) {
  const { event, parentEvent, valid, webConfigEnabled, ecommerceEnabled, shopifyConfigEnabled, shopifyStoreFronts } = props;

  const disableControls = typeof(parentEvent) === "object";

  // List shopify storefronts
  let storeFronts = [];
  shopifyStoreFronts && shopifyStoreFronts.forEach(store => {
    storeFronts.push({
      text: store.replace(/\/$/, ""),
      value: store.replace(/\/$/, "")
    });
    return storeFronts;
  });

  let eventEcommerceToggle;
  if (event.id > 0) {
    eventEcommerceToggle = (+event.webenabled > 0 || +event.shopify_enabled > 0) ? 1 : 0;
  } else {
    eventEcommerceToggle = ecommerceEnabled > -1 ? ecommerceEnabled : (webConfigEnabled || shopifyConfigEnabled) ? 1 : 0;
  }

  const eventShopifyToggle = +event.shopify_enabled > -1 ? +event.shopify_enabled : shopifyConfigEnabled ? 1 : 0;

  // Define validation rules
  const rules = {};
  if (ecommerceEnabled > 0) { // check for bump-ecommerce and bump-shopify
    if (+event.webenabled < 1 && +event.shopify_enabled < 1) {
      rules['ecommercePlatform'] = "required";
    } else {
      delete rules['ecommercePlatform'];
    }
    if (+event.shopify_enabled > 0 && event.shopify_storefront === '') {
      rules['shopify_storefront'] = "required";
    } else {
      delete rules['shopify_storefront'];
    }
  }

  if (event.rsu_enabled < 1 && eventEcommerceToggle < 1 && +event.is_import_raffle < 1) { // check for event-level rsu/ecomm
    rules['rsu_enabled'] = "required|min:1";
  } else {
    delete rules['rsu_enabled'];
  }

  const customMessages = {
    "required.shopify_storefront": "You enabled shopify for this event, please select a storefront from the list.",
    "required.ecommercePlatform": "A platform must be selected.",
    "min.rsu_enabled": "A sales method must be selected."
  }

  props.setRules(rules, customMessages);

  return (
    <Form size="large" error={valid.errorCount > 0}>
      <Message
        error
        content={Object.keys(valid.errors.all()).map((item, key) => {
          return (
            <span key={key}>
              {valid.errors.first(item)}
              <br />
            </span>
          );
        })}
      />
      <Form.Radio
        toggle
        size="large"
        label={
          event.rsu_enabled > 0 ?
            <label><span><Icon name="tablet" color="green" fitted /></span> RSU Enabled</label> :
            <label><span><Icon name="tablet" color="red" fitted /></span> RSU Disabled</label>
        }
        value={event.rsu_enabled}
        name="event.rsu_enabled"
        className="radioToggleBtn"
        checked={event.rsu_enabled > 0} // Set to default checked
        onChange={props.handleChange}
        disabled={disableControls}
      />
      <Form.Radio
        toggle
        size="large"
        label={
          eventEcommerceToggle > 0 ?
            <label><span><Icon name="shop" color="green" fitted /></span> E-Commerce Enabled</label> :
            <label><span><Icon name="shop" color="red" fitted /></span> E-Commerce Disabled</label>
        }
        value={eventEcommerceToggle}
        name="ecommerceEnabled"
        className="radioToggleBtn"
        checked={eventEcommerceToggle > 0 ? true : false} // Set to default checked if tenant level websales/shopify config(s) enabled
        onChange={props.handleChange}
        disabled={event.id > 0 || disableControls}
      />
      {eventEcommerceToggle > 0 && <Header as='h3'>Choose a platform:</Header>}
      {eventEcommerceToggle > 0 && <Form.Radio
        size="large"
        label="Bump E-Commerce"
        value="bump-ecommerce"
        name="ecommercePlatform"
        checked={+event.webenabled > 0} // Set to checked when Bump-Ecommerce enabled
        onChange={props.handleChange}
        disabled={!webConfigEnabled || event.id > 0 || disableControls}
      />}
      {eventEcommerceToggle > 0 && <Form.Radio
        size="large"
        label="Bump Shopify"
        value="bump-shopify"
        name="ecommercePlatform"
        checked={eventShopifyToggle > 0 ? true : false} // Set to checked when Bump-Shopify enabled
        onChange={props.handleChange}
        disabled={!shopifyConfigEnabled || event.id > 0 || disableControls} // Disabled mid-event or if tenant shopify config is turned off
      />}
      {eventShopifyToggle > 0 && <Form.Select
        label="Choose a Shopify storefront"
        name="event.shopify_storefront"
        value={event.shopify_storefront}
        options={storeFronts}
        onChange={props.handleChange}
        disabled={!shopifyConfigEnabled || event.id > 0 || disableControls} // Disabled mid-event or if tenant shopify config is turned off
      />}
      {eventShopifyToggle < 1 && <Form.Field>
        <label>
          <Popup
            trigger={
              <span>
                <Icon name="help circle" color="blue" fitted /> Countdown Title
              </span>
            }
            content="This text will appear above the Countdown Timer on E-commerce"
            inverted
            wide
          />
        </label>
        <Form.TextArea
          name="event.content_box_right"
          value={event.content_box_right || ""}
          onChange={props.handleChange}>
        </Form.TextArea>
      </Form.Field>}

      <Button
        type="button"
        primary
        size="large"
        content="Save And Continue"
        onClick={() => props.handleStep("pricing")}
        floated="right"
      />
      <Button
        type="button"
        size="large"
        content="Go Back"
        onClick={() => props.handleStep("non-profit")}
        floated="right"
      />

    </Form>
  );
}

export default Sales;
